import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class ChangeConfirmation {
  /**
   * 受付登録
   * @param {string} lgCd 市町村コード
   * @param {number} receptionId 受付ID
   * @param {object} receptInfo 受付情報
   * @param {Array} business 用件
   * @param {Array} recItems 申請項目
   * @param {object} reserveInfo 予約情報
   * @param {string} userCd 利用者コード
   * @param {number} rsvSetId 予約設定ID
   * @param {object} place 予約施設情報
   * @param {boolean} useHome 自宅を使用するかどうか
   * @param {number} rsvFlag 予約フラグ
   * @return {Promise<Boolean>} 登録成否
   */
  updateReception = async (
    lgCd,
    receptionId,
    business,
    recItems,
    reserveInfo,
    sameDay,
    sameTime,
    userCd,
    rsvSetId,
    place,
    useHome,
    rsvFlag,
    businessChangeMode,
    businessChanged,
    answerList,
    numOfAttendees,
    noteFromForm,
    personalInfo,
    formSetId
  ) => {
    const result = await requestManager.put(`${API_PATH}/changeconfirm/u`, {
      lgCd,
      receptionId,
      business,
      recItems,
      reserveInfo,
      sameDay,
      sameTime,
      userCd,
      rsvSetId,
      place,
      useHome,
      rsvFlag,
      businessChangeMode,
      businessChanged,
      answerList,
      numOfAttendees,
      noteFromForm,
      personalInfo,
      formSetId,
    });

    return result.data;
  };

  /**
   * 予約設定マスタ検索
   * @param {number} rsvSetId 予約設定のID
   * @param {string} lgCd 市町村コード（business_change_mode 取得用）
   * @returns 予約設定情報（tellStart, businessChangeMode 等）
   */
  searchReserveSetting = async (rsvSetId = null, lgCd = null) => {
    const filter = { rsv_set_id: rsvSetId, enable: true, lgCd };
    const result = await requestManager.get(`${API_PATH}/changeconfirm/r/reserve-setting`, filter);
    return result.data;
  };

  /**
   * 前回の予約フォーム回答を取得
   * @param {string} receptionId 受付ID
   * @returns {Array} answerList 前回の回答リスト
   */
  getPreviousAnswers = async (receptionId) => {
    const result = await requestManager.get(`${API_PATH}/changeconfirm/r/previous-answers`, {
      receptionId,
    });
    return result.data;
  };

  /**
   * 同一アドレス、電話番号による予約数を数える
   * @param {*} rsvSetId 予約設定ID
   * @param {*} sendType 送信方法
   * @param {*} mailAddress メールアドレス
   * @param {*} telNum 電話番号
   * @returns 現在の予約数
   */
  searchReserveCount = async (rsvSetId, sendType, mailAddress, telNum) => {
    const filter = {
      rsvSetId,
      sendType,
      mailAddress,
      telNum,
      enable: true,
    };
    const params = { filter };
    const result = await requestManager.get(`${API_PATH}/changeconfirm/r/reserve-count`, params);
    return result.data;
  };
}

export default new ChangeConfirmation();
